import React from 'react'
import { ReactComponent as HandShake } from 'App/assets/handshake.svg'
import { Container } from './CompleteDelete.styles'
import { Link } from '../DeleteForm/DeleteForm.styles'

export const CompleteDelete = () => {
	return (
		<Container>
			<HandShake />
			<p>
				Te confirmamos que recibimos tu solicitud de borrado de tu cuenta y ya
				está en progreso. Este proceso puede tomar de 2 a 3 días hábiles.
			</p>
			<p>
				Es posible que mantengamos temporalmente{' '}
				<Link
					variant="small"
					onClick={() =>
						window.open('https://terminosycondiciones.welbecare.com/', '_blank')
					}
				>
					algunos de tus datos
				</Link>{' '}
				para cumplir con la regulaciones que nos lo exigen. No te preocupes, los
				eliminaremos tan pronto sea posible.
			</p>
			<p>
				Si tienes alguna duda puedes escribirnos al siguiente correo:{' '}
				<Link
					variant="small"
					onClick={() => window.open('mailto:support@welbecare.com/', '_blank')}
				>
					support@welbecare.com
				</Link>
			</p>
		</Container>
	)
}
